module.exports = __webpack_public_path__ + "img/popularize-banner.5e736401.png";